export default "__VITE_ASSET__CGvinOQs__"